const time = {
    justNow: 'たった今',
    minutesAgo: '{{count}}分前',
    hoursAgo: '{{count}}時間前',
    daysAgo: '{{count}}日前',
    weeksAgo: '{{count}}週間前',
    monthsAgo: '{{count}}ヶ月前',
    yearsAgo: '{{count}}年前',
    ago: '{{value}}前',
  };

export default time;
